export default __webpack_public_path__ + "static/media/frame-warlord.7be4e964.png";